import React from "react"
import {Link} from 'gatsby'
import {css} from '@emotion/core'
import styled from '@emotion/styled'

export const buttonStyles = css`
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 4px;
  background: #fff;
  color: #184233;
  border: 2px solid #184233;
  padding: 1rem 3rem;
  transition: 150ms ease-in-out;
  transition-property: background-color, color;

  &:hover {
    background-color: #184233;
    color: #fff;
  }
`

export default styled(Link)`
  ${buttonStyles}
`